<template>
  <div class="itemPackages">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <ItemPackagesTable
      @create-item-package="onCreateItemPackage"
      @edit-item-package="onEditItemPackage"
    />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import ItemPackagesTable from '@/components/ItemPackages/ItemPackagesTable';

export default {
  name: 'ItemPackages',
  components: {
    Breadcrumbs,
    ItemPackagesTable,
  },
  computed: {
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('itemPackages') }];
    },
  },
  methods: {
    onCreateItemPackage() {
      this.$router.push({ name: 'ItemPackageCreatePage' });
    },
    onEditItemPackage(itemPackage) {
      this.$router.push({
        name: 'ItemPackageEditPage',
        params: { itemPackageNumber: itemPackage.number },
      });
    },
  },
};
</script>

<style lang="scss"></style>
